import { Component, OnInit } from '@angular/core';
import { catchError, first, of } from 'rxjs';
import { ConfigurationsService } from '../../services/configurations.service';
import { GungNotificationService } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'lib-offer-configuration',
    templateUrl: './offer-configuration.component.html',
    styleUrl: './offer-configuration.component.scss',
    standalone: false
})
export class OfferConfigurationComponent implements OnInit {
  private readonly configurationId = 'OfferDbConfig';
  offerConfiguration: OfferConfiguration;

  constructor(
    protected configurationService: ConfigurationsService,
    protected gungNotificationService: GungNotificationService,
    protected translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.configurationService
      .getConfigurationsByIds([this.configurationId])
      .pipe(first())
      .subscribe(configuration => {
        if (!configuration) {
          return;
        }

        this.offerConfiguration = configuration[0];
      });
  }

  save(): void {
    this.configurationService
      .updateConfiguration(this.offerConfiguration)
      .pipe(
        first(),
        catchError((err, caught) => {
          this.gungNotificationService.notify(
            this.translateService.instant('ERROR_SAVING_CONFIGURATION'),
            this.translateService.instant('ERROR_SAVING_OFFER_CONFIGURATION_MESSAGE'),
            'error'
          );
          return of(null);
        })
      )
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.gungNotificationService.notify(
          this.translateService.instant('CONFIGURATION_SAVED'),
          this.translateService.instant('OFFER_CONFIGURATION_SAVED_MESSAGE'),
          'success'
        );
      });
  }
}

interface OfferConfiguration {
  offerSubject: string;
}
